import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaCamera, FaHeart, FaCalendarAlt, FaExpand, FaTimes } from 'react-icons/fa';
import './AlbumPage.css';

const AlbumPage = () => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  
  // 使用 letter_photo 目录下的 l1 到 l19 图片
  const photos = [
    { id: 1, url: '/letter_photo/l1.jpg', title: '照片 1', date: '', description: '', location: '' },
    { id: 2, url: '/letter_photo/l2.jpg', title: '照片 2', date: '', description: '', location: '' },
    { id: 3, url: '/letter_photo/l3.jpg', title: '照片 3', date: '', description: '', location: '' },
    { id: 4, url: '/letter_photo/l4.jpg', title: '照片 4', date: '', description: '', location: '' },
    { id: 5, url: '/letter_photo/l5.jpg', title: '照片 5', date: '', description: '', location: '' },
    { id: 6, url: '/letter_photo/l6.jpg', title: '照片 6', date: '', description: '', location: '' },
    { id: 7, url: '/letter_photo/l7.jpg', title: '照片 7', date: '', description: '', location: '' },
    { id: 8, url: '/letter_photo/l8.jpg', title: '照片 8', date: '', description: '', location: '' },
    { id: 9, url: '/letter_photo/l9.jpg', title: '照片 9', date: '', description: '', location: '' },
    { id: 10, url: '/letter_photo/l10.jpg', title: '照片 10', date: '', description: '', location: '' },
    { id: 11, url: '/letter_photo/l11.jpg', title: '照片 11', date: '', description: '', location: '' },
    { id: 12, url: '/letter_photo/l12.jpg', title: '照片 12', date: '', description: '', location: '' },
    { id: 13, url: '/letter_photo/l13.jpg', title: '照片 13', date: '', description: '', location: '' },
    { id: 14, url: '/letter_photo/l14.jpg', title: '照片 14', date: '', description: '', location: '' },
    { id: 15, url: '/letter_photo/l15.jpg', title: '照片 15', date: '', description: '', location: '' },
    { id: 16, url: '/letter_photo/l16.jpg', title: '照片 16', date: '', description: '', location: '' },
    { id: 17, url: '/letter_photo/l17.jpg', title: '照片 17', date: '', description: '', location: '' },
    { id: 18, url: '/letter_photo/l18.jpg', title: '照片 18', date: '', description: '', location: '' },
    { id: 19, url: '/letter_photo/l19.jpg', title: '照片 19', date: '', description: '', location: '' }
  ];

  const openPhoto = (photo) => {
    setSelectedPhoto(photo);
  };

  const closePhoto = () => {
    setSelectedPhoto(null);
  };

  const nextPhoto = () => {
    if (selectedPhoto) {
      const currentIndex = photos.findIndex(p => p.id === selectedPhoto.id);
      const nextIndex = (currentIndex + 1) % photos.length;
      setSelectedPhoto(photos[nextIndex]);
    }
  };

  const prevPhoto = () => {
    if (selectedPhoto) {
      const currentIndex = photos.findIndex(p => p.id === selectedPhoto.id);
      const prevIndex = (currentIndex - 1 + photos.length) % photos.length;
      setSelectedPhoto(photos[prevIndex]);
    }
  };

  return (
    <motion.div
      className="album-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8 }}
    >
      {/* 顶部区域 */}
      <div className="album-top-section">
        <Link to="/" className="back-btn">
          <FaArrowLeft /> 返回首页
        </Link>
        
        <motion.div 
          className="album-header"
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          <h1 className="album-title">
            <FaCamera className="title-icon" />
            时光相册
            <FaHeart className="title-icon" />
          </h1>
          <p className="album-subtitle">珍藏我们每一个美好的瞬间</p>
        </motion.div>
      </div>

      {/* 波浪分隔 */}
      <div className="album-wave-divider">
        <svg viewBox="0 0 600 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <defs>
            <linearGradient id="albumWaveGradient" x1="0%" y1="100%" x2="0%" y2="0%">
              <stop offset="0%" style={{stopColor: 'rgba(255, 240, 245, 0.4)', stopOpacity: 1}} />
              <stop offset="30%" style={{stopColor: 'rgba(255, 228, 235, 0.5)', stopOpacity: 1}} />
              <stop offset="70%" style={{stopColor: 'rgba(255, 205, 215, 0.7)', stopOpacity: 1}} />
              <stop offset="100%" style={{stopColor: 'rgba(255, 182, 193, 0.8)', stopOpacity: 1}} />
            </linearGradient>
          </defs>
          <path d="M0,100 Q150,50 300,100 T600,100 L600,200 L0,200 Z" fill="url(#albumWaveGradient)"/>
        </svg>
      </div>

      {/* 底部区域 */}
      <div className="album-bottom-section">
        <div className="album-container">

        <motion.div
          className="photo-stats"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          <div className="stat-item">
            <span className="stat-number">{photos.length}</span>
            <span className="stat-label">张照片</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">365</span>
            <span className="stat-label">天回忆</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">∞</span>
            <span className="stat-label">份爱意</span>
          </div>
        </motion.div>

        <motion.div
          className="photo-grid"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          {photos.map((photo, index) => (
            <motion.div
              key={photo.id}
              className="photo-item"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.8 + index * 0.1, duration: 0.5 }}
              whileHover={{ scale: 1.05, y: -10 }}
              onClick={() => openPhoto(photo)}
            >
              <div className="photo-wrapper">
                <img src={photo.url} alt={photo.title} className="photo-image" />
                <div className="photo-overlay">
                  <FaExpand className="expand-icon" />
                  <div className="photo-info">
                    <h3 className="photo-title">{photo.title}</h3>
                    <div className="photo-date">
                      <FaCalendarAlt />
                      <span>{photo.date}</span>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="album-footer"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2, duration: 0.8 }}
        >
          <div className="love-message">
            <FaHeart className="heart-icon" />
            <span>每一张照片都是我们爱情故事的见证</span>
            <FaHeart className="heart-icon" />
          </div>
        </motion.div>
        </div>
      </div>

      {/* 照片详情模态框 */}
      {selectedPhoto && (
        <motion.div
          className="photo-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={closePhoto}
        >
          <motion.div
            className="photo-detail"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={closePhoto}>
              <FaTimes />
            </button>
            
            <div className="photo-navigation">
              <button className="nav-btn prev-btn" onClick={prevPhoto}>
                ‹
              </button>
              <button className="nav-btn next-btn" onClick={nextPhoto}>
                ›
              </button>
            </div>

            <div className="detail-image-wrapper">
              <img 
                src={selectedPhoto.url} 
                alt={selectedPhoto.title} 
                className="detail-image" 
              />
            </div>

            <div className="detail-info">
              <h2 className="detail-title">{selectedPhoto.title}</h2>
              <div className="detail-meta">
                <div className="detail-date">
                  <FaCalendarAlt />
                  <span>{selectedPhoto.date}</span>
                </div>
                <div className="detail-location">
                  <span>📍 {selectedPhoto.location}</span>
                </div>
              </div>
              <p className="detail-description">{selectedPhoto.description}</p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </motion.div>
  );
};

export default AlbumPage;


